var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 55,
    viewBox: "0 0 146 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3094 24.1367L50.7949 31.8338L53.2804 24.1367H55.9097L52.3755 34.3662H49.2002L45.6802 24.1367H48.3094Z",
    fill: "#252626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5919 34.3662H63.8651V24.1367H61.5919V34.3662Z",
    fill: "#252626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.353 33.4582C77.0598 33.9454 76.6272 34.3335 76.056 34.6233C75.4842 34.9141 74.7918 35.059 73.9786 35.059C72.7533 35.059 71.7444 34.7588 70.9516 34.1572C70.1582 33.5572 69.7262 32.7173 69.6541 31.6396H72.4651C72.5063 32.0543 72.6529 32.3805 72.9049 32.6183C73.1576 32.8572 73.479 32.9761 73.8703 32.9761C74.2104 32.9761 74.4782 32.8832 74.6739 32.6963C74.869 32.5099 74.9671 32.2611 74.9671 31.9503C74.9671 31.6711 74.8769 31.4372 74.697 31.2503C74.5166 31.0645 74.2927 30.9119 74.0249 30.7925C73.757 30.673 73.3865 30.5309 72.9128 30.3651C72.2232 30.1273 71.6593 29.8967 71.2217 29.6739C70.7841 29.451 70.4086 29.1193 70.0945 28.678C69.7804 28.2379 69.623 27.6656 69.623 26.9611C69.623 26.3086 69.7877 25.7435 70.1176 25.2674C70.4469 24.7908 70.9025 24.4253 71.4845 24.171C72.0659 23.9172 72.733 23.7905 73.4846 23.7905C74.6993 23.7905 75.6641 24.0808 76.3803 24.6609C77.0959 25.2415 77.5002 26.0394 77.5926 27.0546H74.7354C74.6841 26.6918 74.5521 26.4043 74.3418 26.192C74.1303 25.9791 73.845 25.8735 73.4846 25.8735C73.1756 25.8735 72.9258 25.9564 72.7352 26.1217C72.5446 26.2876 72.4499 26.5315 72.4499 26.8522C72.4499 27.1115 72.535 27.3321 72.7042 27.513C72.8745 27.6949 73.0876 27.8425 73.3454 27.9564C73.6025 28.0698 73.9735 28.2152 74.4574 28.3905C75.1577 28.6294 75.729 28.8649 76.1716 29.0988C76.6143 29.3316 76.9955 29.6706 77.3146 30.1162C77.6338 30.5619 77.7934 31.1419 77.7934 31.8569C77.7934 32.4375 77.6468 32.9711 77.353 33.4582Z",
    fill: "#252626"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.4504 27.1101C85.9406 27.6752 85.6858 28.4443 85.6858 29.4186C85.6858 30.3818 85.9406 31.1493 86.4504 31.7183C86.9596 32.2884 87.647 32.5732 88.512 32.5732C89.3663 32.5732 90.0509 32.2884 90.5658 31.7183C91.0806 31.1493 91.3377 30.3818 91.3377 29.4186C91.3377 28.4548 91.0834 27.6879 90.5736 27.1183C90.0639 26.5488 89.3765 26.2635 88.512 26.2635C87.647 26.2635 86.9596 26.5455 86.4504 27.1101ZM91.3148 24.5148C92.1545 24.9958 92.8159 25.6649 93.2997 26.5197C93.7836 27.3746 94.026 28.3411 94.026 29.4183C94.026 30.496 93.7813 31.4642 93.2924 32.3246C92.8035 33.1849 92.1392 33.8557 91.2996 34.3373C90.4605 34.8195 89.5318 35.06 88.5122 35.06C87.4927 35.06 86.5634 34.8195 85.7243 34.3373C84.8852 33.8557 84.2209 33.1849 83.732 32.3246C83.2431 31.4642 82.9984 30.496 82.9984 29.4183C82.9984 28.3411 83.2431 27.3746 83.732 26.5197C84.2209 25.6649 84.8852 24.9958 85.7243 24.5148C86.5634 24.0326 87.4927 23.7915 88.5122 23.7915C89.5413 23.7915 90.4763 24.0326 91.3148 24.5148Z",
    fill: "#252626"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.929 30.3809V34.9504H99.8328V23.9927H103.091C104.316 23.9927 105.23 24.278 105.833 24.8475C106.435 25.4171 106.736 26.2 106.736 27.1948C106.736 28.21 106.424 28.9952 105.802 29.5492C105.179 30.1038 104.275 30.3809 103.091 30.3809H100.929ZM105.021 28.8653C105.432 28.4771 105.638 27.9197 105.638 27.1948C105.638 26.4489 105.432 25.8816 105.021 25.4923C104.609 25.1042 103.934 24.9101 102.998 24.9101H100.928V29.4481H102.998C103.934 29.4481 104.609 29.254 105.021 28.8653Z",
    fill: "#252626"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.609 34.0796H117.563V34.9505H112.512V23.9922H113.609V34.0796Z",
    fill: "#252626"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.068 31.4055L126.921 25.4989L124.744 31.4055H129.068ZM129.392 32.2767H124.435L123.446 34.9496H122.288L126.303 24.2407H127.524L131.539 34.9496H130.366L129.392 32.2767Z",
    fill: "#252626"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.269 34.9505H144.172L138.211 25.796V34.9505H137.114V24.0083H138.211L144.172 33.1789V24.0083H145.269V34.9505Z",
    fill: "#252626"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4149 24.4497L0.731201 37.4998H16.098L8.4149 24.4497Z",
    fill: "#004D95"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0549 30.5501L10.3712 17.5H25.7386L18.0549 30.5501Z",
    fill: "#20C1CD"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1908 24.4497L20.5071 37.4998H35.8745L28.1908 24.4497Z",
    fill: "#AA007B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.429f8bf64a88a340b215c2781200a165.svg";
export { ForwardRef as ReactComponent };